import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faClipboardList } from '@fortawesome/free-solid-svg-icons';

import MenuButton from 'Common/MenuButton/MenuButton';
import MenuPage from 'Common/Navigation/MenuPage';
import { infoToastAction } from 'utils';

const Menu = ({ onChange }) => {
	const { isSupervisor } = useSelector(globalState => globalState.user);
	const globalDispatch = useDispatch();

	const handleUploadTemplate = useCallback(() => {
		if (isSupervisor) {
			onChange('upload_template');
		} else {
			globalDispatch(infoToastAction('Supervisor access is required to upload templates'));
		}
	}, [isSupervisor, globalDispatch, onChange]);

	return (
		<>
			<MenuPage title="Upload Files">
				<MenuButton
					title="Template"
					icon={() => <FontAwesomeIcon icon={faCopy} size="9x" />}
					width="80%"
					onClick={handleUploadTemplate}
					supervisorOnly={true}
				/>

				<MenuButton
					title="Terms & Conditions"
					icon={() => <FontAwesomeIcon className="far" icon={faClipboardList} size="9x" />}
					width="80%"
					onClick={() => onChange('upload_terms')}
					supervisorOnly={true}
				/>
			</MenuPage>
		</>
	);
};

export default Menu;
